import { MasterdataFilter } from '@softapps/core/masterdata';

// Keep in sync with the literal in src/federation/module-metadata.ts.
export const SOFTLINE_PERMISSION_MDC_STOCK_POSTING = 'SOFTAPPS.MDC.STOCKPOSTING';

export const SOFTLINE_ROUTE_MDC_STOCK_POSTING = '/mdc-stock-posting';
export const SOFTLINE_ROUTE_MDC_STOCK_POSTING_SETUP_STOCK =
  '/mdc-stock-posting/setup/stock';
export const SOFTLINE_ROUTE_MDC_STOCK_POSTING_SETUP_SYMBOL =
  '/mdc-stock-posting/setup/stock-symbol';

/** Only stock symbols of this document type are valid for a one-sided stock posting. */
export const ONE_SIDED_STOCK_POSTING_SYMBOL_FILTER: MasterdataFilter = {
  type: 'stringEquals',
  name: 'documentType',
  value: 'ONE_SIDED_STOCK_POSTING',
};

/** Where an add-product flow was started; drives the stepper and back navigation. */
export type StockPostingFlowOrigin = 'pallet' | 'storage-location';

export interface StockPostingFlowContext {
  origin?: StockPostingFlowOrigin | null;
  palletKey?: string | null;
  storageLocationId?: number | null;
}
